var akel_utm_source;
if (getUrlVars()['utm_source']) {
    akel_utm_source = getUrlVars()['utm_source'];
    createCookie('akel_utm_source', akel_utm_source);
} else {
    akel_utm_source = readCookie('akel_utm_source') ? readCookie('akel_utm_source') : '';
}

if (getUrlVars()['gclid']) {
    akel_utm_source = 'Google';
    createCookie('akel_utm_source', akel_utm_source);
}

var akel_utm_medium;
if (getUrlVars()['utm_medium']) {
    akel_utm_medium = getUrlVars()['utm_medium'];
    createCookie('akel_utm_medium', akel_utm_medium);
} else {
    akel_utm_medium = readCookie('akel_utm_medium') ? readCookie('akel_utm_medium') : '';
}

if (getUrlVars()['gclid']) {
    akel_utm_medium = 'CPC';
    createCookie('akel_utm_medium', akel_utm_medium);
}

var akel_utm_campaign;
if (getUrlVars()['utm_campaign']) {
    akel_utm_campaign = getUrlVars()['utm_campaign'];
    createCookie('akel_utm_campaign', akel_utm_campaign);
} else {
    akel_utm_campaign = readCookie('akel_utm_campaign') ? readCookie('akel_utm_campaign') : '';
}
var akel_gclid;
if (getUrlVars()['gclid']) {
    akel_gclid = getUrlVars()['gclid'];
    createCookie('akel_gclid', akel_gclid);
} else {
    akel_gclid = readCookie('akel_gclid') ? readCookie('akel_gclid') : '';
}

var confetti_colors = ['#F0F3F7', '#77C9FA', '#309DDF', '#116090', '#00244D'];

function initializeRecaptcha() {
    if (typeof grecaptcha != 'undefined' && grecaptcha != null) {
        // Clear existing reCAPTCHA responses
        $j('input[name="g-recaptcha-response"]').remove();
        grecaptcha.ready(function () {
            grecaptcha
                .execute('6Lcol6kUAAAAAH31_iniOvoDizOKYb6PhsoMieoL', { action: 'homepage' })
                .then(function (token) {
                    // Success handling
                    $j('form:not(.home-filters, .myakel, .acf-form, .nogr, #step-form)').prepend('<input type="hidden" name="g-recaptcha-response" value="' + token + '">');
                    $j('.g-recaptcha-response').wrap('<label class="grr" />');
                    $j('label.grr').prepend('<span class="vh">Recaptcha Validation</span>');
                    $j('#g-recaptcha-response').attr('aria-hidden', true);
                    $j('#g-recaptcha-response').attr('aria-label', 'do not use');
                    $j('#g-recaptcha-response').attr('aria-readonly', true);
                })
                .catch(function () {});
        });
    }
}

function ajaxForm() {
    if ($j('body.sd').length) {
        confetti_colors = ['#0765d9', '#8be8cb', '#2b8142', '#6b54a2', '#ffb612', '#FF5E27'];
    }

    setTimeout(() => {
        var _hsq = (window._hsq = window._hsq || []);
        _hsq.push(['trackPageView']);
        var hubspotutkval = readCookie('hubspotutk') || '';
        if (hubspotutkval != '') {
            $j('[name="hubspotutk"]').val(hubspotutkval);
        }
    }, 500);

    var type1val = 'OP - Online Prospect';
    var type2val = 'OR - Online Realtor';
    if (readCookie('subscribed')) {
        var text = $j('.subscribe-success').data('success');
        var brochure_link = $j('.subscribe-success').data('brochure');
        var brochure_title = $j('.subscribe-success').data('title');
        var brochure_html = '<span class="' + brochure_title + '"><a target="_blank" href="' + brochure_link + '"><span class="btn btn-white btn-block btn-brochure-download">Download <b class="show-sm-x">Your</b> Brochure <i class="fas fa-chevron-right"></i></span></a></span>';
        $j('.subscribe-success>div').prepend('<h2 class="left-lg">' + text + '</h2><div class="right-lg">' + brochure_html + '</div>');

        setTimeout(() => {
            $j('.subscribe-success').addClass('loaded');
            $j('.request-updates .vp-spacer-md').stop(true, false).slideUp(0, 'easeOutCirc');
            $j('.request-updates .subscribe-success').stop(true, false).slideDown(0, 'easeOutCirc');
        }, 0);
    }
    $j('.btn-banner-start').click(function () {
        var el = $j(this);
        el.slideUp(300);
        $j('.banner-form-wrap.start').hide().removeClass('start').slideDown(500, 'easeInOutExpo');
    });
    $j('.subscribe-close').click(function () {
        //eraseCookie('subscribed');
        $j('.subscribe-success').slideUp(0, 'easeOutCirc');
        $j('.request-updates .vp-spacer-md').stop(true, false).slideDown(0, 'easeInCirc');
    });
    $j('#all_communities').click(function () {
        if ($j(this).is(':checked')) {
            $j('#communities option').prop('selected', true);
        } else {
            $j('#communities option').prop('selected', false);
        }
    });
    $j(document).on('click', '.celebrate', function () {
        confetti({
            particleCount: 120,
            spread: 120,
            origin: { y: 0.7 },
            colors: confetti_colors,
        });
    });
    $j(document).on('click', '.top-tagline', function () {
        confetti({
            particleCount: 20,
            spread: 120,
            origin: { x: 0.18, y: 0.18 },
            colors: confetti_colors,
        });
    });
    $j('#teamcount').change(function (e) {
        var el = $j(this);
        var count = Number(el.val());
        updateFormDisplay(count);
    });
    $j('.btn-add-member').click(function (e) {
        e.preventDefault();
        var count = $j('#teamcount').val();
        var newcount = Number(count) + 1;
        updateFormDisplay(newcount);
        $j('#teamcount').val(newcount);
    });
    function updateFormDisplay(count) {
        $j('.team-member').each(function (index) {
            if (count <= index) {
                $j(this).slideUp(300).removeClass('active-member').addClass('hidden-member').find('input[type="text"]').removeAttr('required').removeAttr('data-parsley-required');
            } else {
                $j(this).slideDown(300).removeClass('hidden-member').addClass('active-member').find('input[type="text"]').attr('required', true).attr('data-parsley-required', true);
            }
        });
        if (count > 4) {
            $j('.btn-add-member').hide();
        } else {
            $j('.btn-add-member').show();
        }
    }
    var members = $j('#teamcount').data('default') || 1;
    $j('#teamcount').val(members);
    updateFormDisplay(members);
    $j('input, textarea').placeholder();
    $j('input[name="realtor"]').change(function () {
        var el = $j(this);
        if (el.is(':checked')) {
            $j('input.lead_rating').val(type2val);
        } else {
            $j('input.lead_rating').val(type1val);
        }
    });

    $j('select[name="contact_type"]').change(function () {
        var el = $j(this);
        if (el.val() == 'Realtor') {
            $j('input.lead_rating').val(type2val);
        } else {
            $j('input.lead_rating').val(type1val);
        }
    });
    var $form = $j('form.ajax, form.ajax2, .myakel-ajax');
    $form.find('[name=utm_source]').val(akel_utm_source);
    $form.find('[name=utm_medium]').val(akel_utm_medium);
    $form.find('[name=utm_campaign]').val(akel_utm_campaign);
    $form.find('[name=digital_source]').val(akel_utm_source);
    $form.find('[name=digital_medium]').val(akel_utm_medium);
    $form.find('[name=digital_campaign]').val(akel_utm_medium);
    $form.find('[name=gclid]').val(akel_gclid);
    $j('input[name="firstname"], input[name="your_name"], input[name="floorplan"]').focus(function () {
        if ($j('body').hasClass('pulsed') || $j('.approver-step-1').length) {
            return;
        }
        $j('body').addClass('pulsed');
        var url = `https://api.akel.co/pulse/?run=1`;
        fetch(url, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                var ip_zip = data.data.geo.postal_code || '';
                var ip_state = data.data.geo.region_name || '';
                var ip_city = data.data.geo.city || '';
                var ip_address = data.data.geo.ip || '';
                $j('input[name="ip_zip"]').val(ip_zip);
                $j('input[name="ip_state"]').val(ip_state);
                $j('input[name="ip_city"]').val(ip_city);
                $j('input[name="ip_address"]').val(ip_address);
            })
            .catch(function () {});
    });
    initializeRecaptcha();
    $j('form.ajax').on('submit', function (e) {
        var form = $j(this);
        e.preventDefault();
        form.parsley().validate();
        var hubspotutkval = readCookie('hubspotutk') || '';
        if (hubspotutkval != '') {
            $j('[name="hubspotutk"]').val(hubspotutkval);
        }
        if (form.parsley().isValid()) {
            form.find('button[type="submit"]').addClass('working');
            form.find('button[type="submit"]').attr('disabled', true);
            formPost(form);
        }
    });

    $j('input[type="checkbox"]').click(function () {
        var cbx = $j(this);
        var cbx_name = cbx.attr('name');
        if (cbx.is(':checked') == true) {
            $j('input[type="hidden"][name="' + cbx_name + '"]').val('Yes');
        } else {
            $j('input[type="hidden"][name="' + cbx_name + '"]').val('No');
        }
    });
    function formPost(form) {
        var error = false;
        var button = form.find('button[type="submit"]');
        var template = $j('button[type="submit"].working').parents().find('input[name="template"]').val();
        var btnstart = $j('button[type="submit"].working span').html() || 'Submit';
        var action = $j('button[type="submit"].working').parent().find('input[name="action"]').val();
        var message = $j('button[type="submit"].working').parent().parent().find('textarea[name="message"]').val();
        var success = $j('button[type="submit"].working').data('success');
        var success_title = $j('button[type="submit"].working').data('success-title') || 'Success!';
        var success_thanks = 'Thank you! <i class="fa-solid fa-message-smile fa-bounce ml10"></i>';
        var ssurl = form.data('ss') || 'https://script.google.com/macros/s/AKfycby8H62nV1hksfANMM1ccW_Qtr1kEhOgAlbZYhPIIPm4LiqIEus/exec';
        if (template == 'trade_partners_register') {
            $j('input[type="checkbox"]').each(function () {
                var cbx = $j(this);
                var cbx_name = cbx.attr('name');
                if (cbx.is(':checked') == true) {
                    $j('input[type="text"][name="' + cbx_name + '"]').val('Yes');
                }
            });
        }
        var formData = form.serializeArray();
        //var submit_date = new Date().toJSON().slice(0,19);
        var f = formData.find(f => f.name === 'contact_type');
        var contact_type = formData.find(f => f.name === 'realtor') ? 'Realtor' : f ? f.value : 'Prospect';

        var d = new Date();
        d.toLocaleString('en-US', { timeZone: 'America/New_York' });
        formData.push({
            name: 'date',
            value: d,
        });
        formData.push({
            name: 'submit_date',
            value: d,
        });
        formData.push({
            name: 'contact_type',
            value: contact_type,
        });
        formData.push({
            name: 'ts',
            value: $j('body').attr('data-time') || '',
        });
        if (!message) {
            formData.push({
                name: 'message',
                value: '',
            });
        }
        $j('div.success-message.sm-' + template).remove();
        $j.ajax({
            type: 'POST',
            url: window.location.href,
            data: formData,
            dataType: 'html text',
        })
            .done(function (data) {
                var confettiTimer = 500;
                var aform = $j('.akel-form-' + template);
                var atext = $j('.akel-form-text-' + template);
                if (checkJSON(data)) {
                    data = JSON.parse(data);
                } else {
                    error = true;
                }
                setTimeout(function () {
                    $j(window).trigger('resize');
                }, 600);
                if (data.ctaurl && data.ctaurl != '') {
                    setTimeout(() => {
                        window.location = data.ctaurl;
                    }, 360);
                    return;
                }

                if (error || !data.valid) {
                    var parsleyForm = $j('form.' + template + '-form').parsley();
                    var required_fields = data.invalid_fields || null;
                    var required_fields_text = 'Missing Required Fields:<br><strong>';
                    var error_text = 'Error Sending';
                    var error_text2 = 'Please Try Again';
                    if (required_fields) {
                        error_text = 'Missing Required Fields';
                        error_text2 = 'Please Check and Try Again';
                        required_fields.forEach(function (fieldName, index) {
                            var field = parsleyForm.fields.filter(function (field) {
                                return field.$element.attr('name') === fieldName;
                            })[0];
                            if (field) {
                                field.addError('manual-error', {
                                    message: 'This field is required.',
                                    assert: false,
                                });
                                field.$element.removeClass('parsley-success').addClass('parsley-error');
                            }
                            let label = getLabel(fieldName);
                            required_fields_text += (index > 0 ? '<br>' : '') + label;
                        });
                        required_fields_text += '</strong>';
                    } else {
                        initializeRecaptcha();
                        required_fields_text = '<strong>Submission Failed:</strong> ' + (typeof data === 'object' ? JSON.stringify(data) : data);
                    }
                    button.removeClass('working').addClass('btn-error');
                    button.parent().find('.error-list').remove();
                    button.before('<span class="error-list">' + required_fields_text + '</span>');
                    button.text(error_text);
                    setTimeout(function () {
                        button.text(error_text2);
                    }, 1500);
                    setTimeout(function () {
                        button.removeAttr('disabled');
                    }, 3500);
                    setTimeout(function () {
                        button.removeClass('btn-error');
                        button.html(btnstart + ' <i class="fas fa-chevron-right"></i>');
                    }, 4000);
                    return;
                }

                if (template == 'ndaform') {
                    success = data.success || 'Please check your email.';
                    scrollToTop();
                    confettiTimer = 500;
                    if (typeof confetti != 'undefined' && confetti != null) {
                        // '#00244D','#14324B'
                        setTimeout(function () {
                            confetti({
                                particleCount: 120,
                                spread: 120,
                                origin: { y: 0.7 },
                                colors: confetti_colors,
                            });
                        }, confettiTimer);
                    }
                    aform.after('<div style="display:none;" class="success-message sm-' + template + '"><h3 style="margin-top:0;" class="hua-sp celebrate"><span><i class="fas fa-check green"></i> ' + success_title + '</span></h3><hr class="mb30"> <p><span class="hua celebrate">' + success + '</span></p></div>');
                    aform.slideUp(500);
                    atext.slideUp(500);
                    if ($j('.success-message').length) {
                        $j('.success-message').slideDown(500);
                    }
                    return;
                }
                if (template == 'bid-access') {
                    if (data.error) {
                        aform.find('p.akel-notify').html(data.error);
                        button.removeClass('working').addClass('btn-error');
                        button.text('Error');
                        initializeRecaptcha();
                        setTimeout(function () {
                            button.text('Please Try Again');
                        }, 1500);
                        setTimeout(function () {
                            button.removeAttr('disabled');
                        }, 3500);
                        setTimeout(function () {
                            button.removeClass('btn-error');
                            button.html('<span>' + btnstart + '</span> <i class="fas fa-chevron-right"></i>');
                        }, 4000);
                        return;
                    }
                    success = data.success || 'Please check your email.';
                    scrollToTop();
                    confettiTimer = 500;
                    if (typeof confetti != 'undefined' && confetti != null) {
                        // '#00244D','#14324B'
                        setTimeout(function () {
                            confetti({
                                particleCount: 120,
                                spread: 120,
                                origin: { y: 0.7 },
                                colors: confetti_colors,
                            });
                        }, confettiTimer);
                    }
                    aform.find('fieldset').prepend('<div style="display:none;" class="success-message sm-' + template + '"><h3 style="margin-top:0;" class="hua-sp celebrate"><span><i class="fas fa-check green"></i> ' + success_title + '</span></h3><hr class="mb30"> <p><span class="hua celebrate">' + success + '</span></p></div>');
                    //aform.slideUp(500);
                    //atext.slideUp(500);
                    aform.find('p.instructions').slideUp(500);
                    aform.find('p.akel-notify').slideUp(500);
                    aform.find('ol').slideUp(500);
                    if ($j('.success-message').length) {
                        $j('.success-message').slideDown(500);
                    }
                    $j('button[type="submit"].working').text('Success!').removeClass('working').addClass('btn-success');
                    initializeRecaptcha();
                    return;
                }
                if (data.valid) {
                    var whitelistedHosts = ['akel.co', 'akelhomes.com', 'myakel.com'];
                    if (whitelistedHosts.includes(window.location.hostname) && template != 'bid' && template != 'ndaform') {
                        var gSheetData = unsetField(formData, 'signature_image');
                        var rsvpSelect = form.find('select[name="rsvp_option"] option:selected');
                        if (rsvpSelect.length) {
                            gSheetData = gSheetData.map(function (field) {
                                return field.name === 'rsvp_option' ? { name: 'rsvp_option', value: rsvpSelect.text().trim() } : field;
                            });
                        }
                        $j.ajax({
                            url: ssurl,
                            crossDomain: true,
                            data: gSheetData,
                        })
                            .done(function (data) {
                                // Handle success
                            })
                            .fail(function () {});
                    }
                    var whitelistedHosts = ['akelhomes.com'];
                    if (!whitelistedHosts.includes(window.location.hostname)) {
                        createCookie('subscribed', true, 7);
                    }
                    $j('button[type="submit"].working').text('Success!').removeClass('working').addClass('btn-success');
                    $j('.autofiller').remove();
                    if (template == 'contact-lg') {
                        aform.find('ol.field-group').slideUp(300);
                        aform.find('ol.field-group.submit').after('<div style="display:none; clear:both; width:100%;" class="success-message sm-' + template + '"><ol class=" clear mb0 padb0"><li class="mb0"><h3 style="margin-top:0;" class="hua-sp celebrate"><span><i class="fas fa-check green"></i> ' + success_title + '</span></h3> <p><span class="hua celebrate">' + success + '</span></p></li></ol></div>');
                    } else {
                        var success_message = success_title;
                        if (template == 'feedback' || template == 'realtorsource') {
                            success_message = success_thanks;
                        }
                        aform.after('<div style="display:none;" class="success-message sm-' + template + '"><h3 style="margin-top:0;" class="hua-sp celebrate"><span>' + success_message + '</span></h3><hr class="mb30"> <p><span class="hua celebrate">' + success + '</span></p></div>');
                        aform.slideUp(300);
                        atext.slideUp(300);
                        if ($j('.success-content').length) {
                            $j('.success-content').slideDown(300);
                        }
                    }
                    $j('.btn-appointment-back').fadeOut(300);
                    try {
                        if (data && data.calendar_links) {
                            $j('div.success-message.sm-' + template).append(data.calendar_links);
                        }
                    } catch (e) {}
                    setTimeout(function () {
                        $j('.contact-type-toggle, .realtor-field').slideUp(300);
                        $j('div.success-message.sm-' + template).slideDown(300);
                    }, 100);
                    if (data.data) {
                        var html = '<div style="display:none;" class="brochure-content extra-content">';
                        //html += '<h2 class="mt0 padt20 mb0 padb30">'+title+'</h2>';
                        //html += '<div>'+content+'</div>';
                        html += '<div class="brochures"><ul>' + data.html + '</ul></div>';
                        html += '</div>';
                        $j('div.success-message.sm-' + template).after(html);
                        $j('div.extra-content').slideDown(300);
                    }
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        event: action,
                        community: community,
                        floorplan: floorplan,
                        referer: referer,
                        pageurl: page_url,
                    });
                    var confettiTimer = 300;
                    if (template == 'bid') {
                        scrollToTop();
                        confettiTimer = 1200;
                    }
                    if (typeof confetti != 'undefined' && confetti != null) {
                        // '#00244D','#14324B'
                        setTimeout(function () {
                            confetti({
                                particleCount: 120,
                                spread: 120,
                                origin: { y: 0.7 },
                                colors: confetti_colors,
                            });
                        }, confettiTimer);
                    }
                    initializeRecaptcha();
                    return;
                }
                button.removeClass('working').addClass('btn-error');
                button.text('Error Sending');
                initializeRecaptcha();
                setTimeout(function () {
                    button.text('Please Try Again');
                }, 1500);
                setTimeout(function () {
                    button.removeAttr('disabled');
                }, 3500);
                setTimeout(function () {
                    button.removeClass('btn-error');
                    button.html(btnstart + ' <i class="fas fa-chevron-right"></i>');
                }, 4000);
            })
            .fail(function (xhr, ajaxOptions, thrownError) {
                button
                    .removeClass('working')
                    .addClass('btn-error')
                    .text('Submission Error: ' + xhr.statusText);
                initializeRecaptcha();
                setTimeout(function () {
                    button.text('Please Try Again');
                }, 2000);
                setTimeout(function () {
                    button.text('Submit').removeClass('disabled btn-error').prop('disabled', false);
                }, 5000);
            });
    }
    setTimeout(function () {
        //$j('.btn-request-virtual-tour').click();
        //$j('.autofiller').click();
        //$j('.tours-requested .submit button').click();
    }, 500);
    var $phone = $j('input[name="phone"][data-inputmask-mask]');
    $phone.inputmask();
    $phone.on('input', function () {
        var $this = $j(this);
        var raw = $this.inputmask('unmaskedvalue') || '';
        raw = raw.replace(/\D/g, '');
        if (raw.length > 0 && raw.charAt(0) === '1') {
            if (raw.length === 1) {
                raw = '';
            } else {
                raw = raw.substring(1);
            }
            $this.inputmask('setvalue', raw);
        }
    });

    $j('.btn-subscribe-continue').click(function () {
        var el = $j(this);
        var form = $j('.akel-form-subscribe-banner');
        var communites_select = form.find('select[name="communities"]');
        var realtor_select = form.find('select[name="contact_type"]');
        var firstname = form.find('[name="firstname"]');
        var style = el.data('style');
        var next = el.data('next');
        if (next == 'name-step') {
            if (communites_select.val() && realtor_select.val()) {
                el.parent().remove();
                $j('form.inline li.type-step').hide();
                $j('form.inline li.' + next + ', form.inline li.submit-step').show();
                $j('form.inline').addClass('col4');
                //form.parsley().reset();
                //$j('form.inline input[name="firstname"]').focus();
            } else {
                form.submit();
            }
        } else {
            if (firstname.val()) {
                //el.addClass('btn-green').removeClass('btn-primary');
                //el.html('Almost There!');
                setTimeout(function () {
                    el.parent().fadeOut(500, 0);
                }, 0);
                setTimeout(function () {
                    $j('form li.' + next + ', form li.submit-step').each(function (index) {
                        var step = $j(this);
                        setTimeout(function () {
                            step.fadeIn(300);
                        }, 240 * index);
                    });
                    //form.parsley().reset();
                }, 500);
            } else {
                form.submit();
            }
        }
    });

    if (!!$j('.signature-form').length) {
        initSignatureValidation();
    }

    if (!!$j('.file-uploader').length) {
        initUploadValidation();
    }
}

function unsetField(formData, fieldName) {
    return formData.filter(function (field) {
        return field.name !== fieldName;
    });
}

function getLabel(inputName) {
    let input = document.querySelector(`[name="${inputName}"]`);
    if (!input) return null;
    let prevElem = input.previousElementSibling;
    if (prevElem && prevElem.tagName === 'SPAN') {
        return prevElem.textContent.replace(/[*:]/g, '');
    }
    return null;
}

function setTimestamp() {
    try {
        var now = Math.floor(Date.now() / 1000);
        jQuery('body').attr('data-time', now);
    } catch (e) {}
}

(function () {
    var params = getUrlVars();
    var verifyId = params['ref'] || params['walkin'] || params['vid'] || params['uid'];
    if (!verifyId) return;
    console.log('[RV] started | vid=' + verifyId.substring(0, 8) + '...');
    var attempts = 0;
    var delays = [1000, 2000, 3000, 4000, 5000];
    function tryRemoteVerify() {
        attempts++;
        var cookie = readCookie('hubspotutk');
        if (cookie) {
            console.log('[RV] cookie found | hutk=' + cookie.substring(0, 8) + '...');
            var postData = {
                remote_verify: 1,
                key: verifyId,
                hutk: cookie,
                source_url: window.location.href.split('?')[0],
            };
            console.log('[RV] posting to relay...', postData);
            $j.ajax({
                type: 'POST',
                url: window.location.href,
                data: postData,
                dataType: 'json',
                success: function (response) {
                    console.log('[RV] relay response:', JSON.stringify(response, null, 2));
                },
                error: function (xhr, status, error) {
                    console.error('[RV] relay error:', {
                        status: xhr.status,
                        statusText: xhr.statusText,
                        responseText: xhr.responseText ? xhr.responseText.substring(0, 500) : null,
                        error: error,
                    });
                },
            });
            return;
        }
        console.log('[RV] try ' + attempts + ' — no cookie yet');
        if (attempts < delays.length) {
            setTimeout(tryRemoteVerify, delays[attempts]);
        } else {
            console.log('[RV] gave up after ' + attempts + ' attempts');
        }
    }
    setTimeout(tryRemoteVerify, delays[0]);
})();
